export default __webpack_public_path__ + "static/media/tj.d42f41d5.jpeg";